import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

// ============================================================================
// FALLS THROUGH SECTION
// "Get paid even if the sale falls through."
// Image on LEFT, text on RIGHT (mirrors and continues the Advance section flow).
// A subtle dotted curved arrow links it visually to the previous section.
// ============================================================================

const PADLOCK_IMAGE =
  "https://customer-assets.emergentagent.com/job_gazeal-preview/artifacts/sqmhfsly_GazealElite-.png";

export default function FallsThroughSection() {
  return (
    <section
      id="falls-through"
      className="relative bg-black pt-4 pb-20 md:pt-2 md:pb-28 overflow-hidden"
      data-testid="falls-through-section">

      {/* Ambient gold glow */}
      <div className="pointer-events-none absolute right-0 top-1/3 h-[420px] w-[420px] rounded-full bg-[#FF914D]/8 blur-3xl opacity-60" />
      <div className="pointer-events-none absolute left-0 bottom-0 h-[320px] w-[320px] rounded-full bg-[#FFDE59]/5 blur-3xl opacity-50" />

      <div className="relative mx-auto max-w-3xl lg:max-w-6xl px-6">

        <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start lg:pt-6">

          {/* LEFT — Padlock image */}
          <div className="lg:col-span-5 order-1 flex justify-center lg:justify-start">
            <div className="relative w-full max-w-[340px]">
              {/* Soft glow ring behind image */}
              <div className="pointer-events-none absolute -inset-6 rounded-[2rem] bg-gradient-to-br from-[#FFDE59]/12 via-transparent to-[#FF914D]/12 blur-2xl" />

              <div className="relative rounded-2xl border border-white/10 bg-white/[0.02] backdrop-blur-sm p-2 sm:p-3">
                <img
                  src={PADLOCK_IMAGE}
                  alt="Golden padlock representing commission protection if a sale falls through."
                  className="w-full h-auto rounded-xl object-contain"
                  loading="lazy"
                  data-testid="falls-through-image" />
              </div>
            </div>
          </div>

          {/* RIGHT — Heading + body */}
          <div className="lg:col-span-7 order-2 lg:pt-4">
            <h2
              className="font-didot italic leading-[1.1] text-white text-4xl sm:text-5xl lg:text-[56px]"
              data-testid="falls-through-heading">
              Get paid even if the
              <br />
              <span className="bg-gradient-to-r from-[#FFDE59] to-[#FF914D] bg-clip-text text-transparent">
                sale falls through.
              </span>
            </h2>

            <p
              className="mt-6 text-base sm:text-lg text-white/65 font-manrope leading-relaxed max-w-xl"
              data-testid="falls-through-body">
              When a deal falls through, the work is already done but the income disappears. As an Elite agent, you can choose to structure your deals so you receive compensation if the sale collapses, giving you protection that isn't available anywhere else.
            </p>

            {/* CTA */}
            <div className="mt-8">
              <Button
                size="lg"
                className="font-semibold shadow-2xl shadow-[#FFDE59]/20"
                onClick={() => document.getElementById('access-section')?.scrollIntoView({ behavior: 'smooth' })}
                data-testid="falls-through-cta-button">
                Unlock Access
                <ChevronRight className="ml-1 h-4 w-4" />
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>);

}
